/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountCrmModule} from '../models/AccountCrmModule';
import type {BooleanJson} from '../models/BooleanJson';
import type {CrmType} from '../models/CrmType';
import type {Error} from '../models/Error';

export interface GetAccountsCrmModules$Request {
    requestBody: Array<number>;
}

export interface GetAccountsCrmModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountsCrmModulesRequest = createAction<PayloadData<void, GetAccountsCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ACCOUNTS_CRM_MODULES__REQUEST');
export const getAccountsCrmModulesSuccess = createAction<PayloadData<{ [key: string]: AccountCrmModule; }, GetAccountsCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ACCOUNTS_CRM_MODULES__SUCCESS');
export const getAccountsCrmModulesFailure = createAction<PayloadData<Error, GetAccountsCrmModules$Request, true>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ACCOUNTS_CRM_MODULES__FAILURE');

export const getAccountsCrmModulesActions = [
    getAccountsCrmModulesRequest,
    getAccountsCrmModulesSuccess,
    getAccountsCrmModulesFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountsCrmModules = (meta: GetAccountsCrmModules$Request, config?: GetAccountsCrmModules$Config) => {
    return {
        CALL_API: {
            types: getAccountsCrmModulesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/crm-modules`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetEnabledAccountCrmModules$Request {
    accountId: number;
}

export interface GetEnabledAccountCrmModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEnabledAccountCrmModulesRequest = createAction<PayloadData<void, GetEnabledAccountCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ENABLED_ACCOUNT_CRM_MODULES__REQUEST');
export const getEnabledAccountCrmModulesSuccess = createAction<PayloadData<Array<CrmType>, GetEnabledAccountCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ENABLED_ACCOUNT_CRM_MODULES__SUCCESS');
export const getEnabledAccountCrmModulesFailure = createAction<PayloadData<Error, GetEnabledAccountCrmModules$Request, true>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ENABLED_ACCOUNT_CRM_MODULES__FAILURE');

export const getEnabledAccountCrmModulesActions = [
    getEnabledAccountCrmModulesRequest,
    getEnabledAccountCrmModulesSuccess,
    getEnabledAccountCrmModulesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEnabledAccountCrmModules = (meta: GetEnabledAccountCrmModules$Request, config?: GetEnabledAccountCrmModules$Config) => {
    return {
        CALL_API: {
            types: getEnabledAccountCrmModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/crm-modules`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetEnabledCrmModules$Request {
    licenseId: number;
    crmType: CrmType;
}

export interface GetEnabledCrmModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEnabledCrmModulesRequest = createAction<PayloadData<void, GetEnabledCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ENABLED_CRM_MODULES__REQUEST');
export const getEnabledCrmModulesSuccess = createAction<PayloadData<boolean, GetEnabledCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ENABLED_CRM_MODULES__SUCCESS');
export const getEnabledCrmModulesFailure = createAction<PayloadData<Error, GetEnabledCrmModules$Request, true>>('CRM_MODULE_SETTINGS_CONTROLLER__GET_ENABLED_CRM_MODULES__FAILURE');

export const getEnabledCrmModulesActions = [
    getEnabledCrmModulesRequest,
    getEnabledCrmModulesSuccess,
    getEnabledCrmModulesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {CrmType} meta.crmType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEnabledCrmModules = (meta: GetEnabledCrmModules$Request, config?: GetEnabledCrmModules$Config) => {
    return {
        CALL_API: {
            types: getEnabledCrmModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.licenseId}/modules/${meta.crmType}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveCrmModules$Request {
    licenseId: number;
    crmType: CrmType;
    booleanJson: BooleanJson;
}

export interface SaveCrmModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveCrmModulesRequest = createAction<PayloadData<void, SaveCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__SAVE_CRM_MODULES__REQUEST');
export const saveCrmModulesSuccess = createAction<PayloadData<void, SaveCrmModules$Request>>('CRM_MODULE_SETTINGS_CONTROLLER__SAVE_CRM_MODULES__SUCCESS');
export const saveCrmModulesFailure = createAction<PayloadData<Error, SaveCrmModules$Request, true>>('CRM_MODULE_SETTINGS_CONTROLLER__SAVE_CRM_MODULES__FAILURE');

export const saveCrmModulesActions = [
    saveCrmModulesRequest,
    saveCrmModulesSuccess,
    saveCrmModulesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {CrmType} meta.crmType
 * @param {BooleanJson} meta.booleanJson
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveCrmModules = (meta: SaveCrmModules$Request, config?: SaveCrmModules$Config) => {
    return {
        CALL_API: {
            types: saveCrmModulesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.licenseId}/modules/${meta.crmType}`,
            TRANSPORT_REQUEST_BODY: meta.booleanJson,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

